export default __webpack_public_path__ + "static/media/Group 434.26423d9e.png";